import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scan3dElevationTranslations() {
  return {
    reference: {
      title: {
        text: $localize`:@@scan3dElevation.reference.title:Reference Elevation`,
        desc: 'Title for the reference elevation value.',
        limit: 30,
      },
      error: {
        text: $localize`:@@scan3dElevation.reference.error:Invalid reference value.`,
        desc: 'Error message when a reference value is not valid.',
        limit: 30,
      },
      activatePicking: {
        text: $localize`:@@scan3dElevation.reference.activatePicking:Activate Picking`,
        desc: 'Tooltip text to activate picking elevation from the 3D view.',
      },
      deactivatePicking: {
        text: $localize`:@@scan3dElevation.reference.deactivatePicking:Deactivate Picking`,
        desc: 'Tooltip text to deactivate picking elevation from the 3D view.',
      },
    },
    tolerance: {
      title: {
        text: $localize`:@@scan3dElevation.tolerance:Tolerance`,
        desc: 'Label for the tolerance value.',
        limit: 30,
      },
      error: {
        text: $localize`:@@scan3dElevation.tolerance.error:Invalid tolerance value.`,
        desc: 'Error message when a tolerance value is not valid.',
        limit: 30,
      },
    },
    offset: {
      title: {
        text: $localize`:@@scan3dElevation.offset.title:Offset`,
        desc: 'Title for the offset value.',
        limit: 30,
      },
      error: {
        text: $localize`:@@scan3dElevation.offset:Invalid offset value.`,
        desc: 'Error message when an offset value is not valid.',
        limit: 30,
      },
    },
    bandCount: {
      text: $localize`:@@scan3dElevation.bandCount:Band Count`,
      desc: 'Title for the band count value.',
      limit: 30,
    },
    legend: {
      title: {
        text: $localize`:@@scan3dElevation.legend.title:Elevation Legend`,
        desc: 'Title for the elevation legend.',
        limit: 30,
      },
      belowReference: {
        text: $localize`:@@scan3dElevation.legend.belowReference:Below`,
        desc: 'Text for the below reference value.',
        limit: 30,
      },
      reference: {
        text: $localize`:@@scan3dElevation.legend.reference:Reference`,
        desc: 'Text for the reference value.',
        limit: 30,
      },
      aboveReference: {
        text: $localize`:@@scan3dElevation.legend.aboveReference:Above`,
        desc: 'Text for the above reference value.',
        limit: 30,
      },
    },
  } satisfies TranslationMap;
}
